import { computed } from 'vue';
import Advertisers, { getAdverPreview } from 'api/advertisers';

import { objProp } from 'utils';
import Apps from 'store/apps.resource';
import { Resource, computedMapById, syncDataToLocalStorage } from './store';

const LS_KEY = 'Apps.state';

export default Resource.build(({ values: { isEmpty, isFetching, list }, state }) => {
  syncDataToLocalStorage('Advertisers.state', state);

  return {
    name: 'Advertisers',
    state,

    values: {
      // ...values,
      byId: computedMapById(state),

      appsByAdvers: computed(() => {
        if (isEmpty.value) {
          if (Apps.isEmpty.value)
            return {};
          else
            return objProp({}, '$noGroup', Apps.list || [], 'C');
        }

        const appsByIds = { ...Apps.byId };
        const map = list.value
          .reduce((acc, adver) => {
            acc[adver.id] = adver.appIds.map(appId => {
              appsByIds[appId] = false;
              return Apps.byId[appId];
            }).filter(Boolean);
            return acc;
          }, {});

        const noGroup = Object.values(appsByIds).filter(Boolean).reverse();
        objProp(map, '$noGroup', noGroup, 'C');
        return map;
      }),

      ready: computed(() => !isFetching.value && !Apps.isFetching.value),

      getAdverPreview,
    },

    actReqs: {
      fetch: Advertisers.fetchList.bind(Advertisers),
      add: Advertisers.create.bind(Advertisers),
      update: Advertisers.update.bind(Advertisers),
      delete: Advertisers.delete.bind(Advertisers),
    },
  };
});
